<template>
  <div class="CR">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/ApprovalIndex" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="content_title">
      <div class="d-flex d-flex-first">
        <div class="flex-item">
          <label class="label">POS Code</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="POSCode"
            placeholder="Please input"
            type="textarea"
            rows="1"
            @keydown.enter.native="keyDown"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">Project Code</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="ProjectCode"
            placeholder="Please input"
            type="textarea"
            rows="1"
            @keydown.enter.native="keyDown"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">POS Name</label>
          <el-input
            style="flex: 1; margin-left: 5px"
            v-model="POSName"
            placeholder="Please input"
            type="text"
          ></el-input>
        </div>
        <div class="flex-item">
          <label class="label">Team</label>
          <el-select
            v-model="Teams"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Teams"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Teams.length !== TeamOptions.length"
              @change="selectAll_Teams"
            >All</el-checkbox>
            <el-option v-for="item in TeamOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>

        <div class="flex-item">
          <label class="label">Region</label>
          <el-select
            v-model="Regions"
            multiple
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
            @change="GetProvinces"
          >
            <el-checkbox
              v-model="check_Regions"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Regions.length !== RegionOptions.length"
              @change="selectAll_Regions"
            >All</el-checkbox>
            <el-option v-for="item in RegionOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Province</label>
          <el-select
            v-model="Provinces"
            multiple
            collapse-tags
            placeholder="Please select"
            @change="GetCitys"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Provinces"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Provinces.length !== ProvinceOptions.length"
              @change="selectAll_Provinces"
            >All</el-checkbox>
            <el-option
              v-for="item in ProvinceOptions"
              :key="item.id"
              :label="item.nameCN"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">City</label>
          <el-select
            v-model="Citys"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Citys"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Citys.length !== CityOptions.length"
              @change="selectAll_Citys"
            >All</el-checkbox>
            <el-option
              v-for="item in CityOptions"
              :key="item.id"
              :label="item.nameCN"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Action</label>
          <el-select
            v-model="Action"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_Action"
              style="margin-left: 20px; width: 200px"
              :indeterminate="Action.length !== ActionOptions.length"
              @change="selectAll_Actions"
            >All</el-checkbox>
            <el-option v-for="item in ActionOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Project Status</label>
          <el-select
            v-model="ProjectStatus"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-option v-for="item in ProjectStatusOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Group Customer</label>
          <el-select
            v-model="GroupCustomers"
            multiple
            collapse-tags
            placeholder="Please select"
            style="margin-left: 5px; flex: 1"
          >
            <el-checkbox
              v-model="check_GroupCustomers"
              style="margin-left: 20px; width: 200px"
              :indeterminate="
                GroupCustomers.length !== GroupCustomerOptions.length
              "
              @change="selectAll_GroupCustomers"
            >All</el-checkbox>
            <el-option v-for="item in GroupCustomerOptions" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="flex-item">
          <label class="label">Financial Year</label>
          <el-select v-model="Year" placeholder="Please select" multiple collapse-tags style="margin-left: 5px; flex: 1;">
            <el-option v-for="item in YearOption" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <div class="CR-btn">
        <el-button class="button-search" @click="Import()" v-if="isntp">Update Financial Year</el-button>
        <el-button class="button-search" @click="Export()">Export</el-button>
        <el-button class="button-search" @click="search()">Search</el-button>
      </div>
      <div class="cr-table">
        <div class="div-pagination">
          <el-pagination
            background
            @current-change="pagingChange"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :page-size="pagenum"
            :page-sizes="[20,30 , 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            ref="multipleTable"
          ></el-pagination>
        </div>
        <div class="table" ref="table">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="tableData"
            :header-cell-style="tableHeaderCell"
            :cell-style="tableCell"
            :height="tableHeight"
            border
            fit
            tooltip-effect="dark"
          >
            <template>
              <el-table-column
                :prop="item.value"
                :label="item.label"
                v-for="(item, index) in tableColumn"
                :key="index"
                :width="item.width"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    style="
                      color: #606266;
                      cursor: pointer;
                      text-decoration: underline;
                    "
                    v-if="item.value === 'projectCode'"
                    @click="goNextPath(scope.row)"
                  >{{ scope.row[item.value] }}</span>
                  <span v-else>{{ scope.row[item.value] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <el-dialog title="Upload File" :visible.sync="dialogUploadVisible" width="50%" :close-on-click-modal="false"
          :destroy-on-close="true" @close="Close">
          <div style="float: left" size="mini">
              <el-upload class="upload-demo" ref="upload" :multiple="false" :file-list="filelist" :limit="2" action
                  :http-request="requestFile" :on-change="handleChange" accept=".xlsx" :auto-upload="false">
                  <el-button slot="trigger" size="mini" type="primary">Choose File</el-button>
                  <el-button style="margin-left: 10px" size="mini" type="success" @click="submitUpload">Upload
                  </el-button>
                  <el-button size="mini" style="margin-left: 10px" class="btn" @click="download(1)" type="primary">
                      Download Template</el-button>
                 <el-link v-if="errShow" style="margin-left: 10px;" size="mini" type="danger"
                      @click.native="download(2)">下载错误文件</el-link>
                  
              </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button size="mini" @click="Close">Cancel</el-button>
          </span>
      </el-dialog>
    </div>
  </div>  
</template>

<script>
import Download from "@/common/js/Download.js";
export default {
  data() {
    return {
      tableData: [],
      tableColumn: [
        {
          label: "Project code",
          value: "projectCode",
          width: "230px"
        },
        {
          label: "POS Name",
          value: "posFullNameCN",
          width: "260px"
        },
        {
          label: "Region",
          value: "region",
          width: "auto"
        },
        {
          label: "Team",
          value: "team",
          width: "auto"
        },
        {
          label: "Project Status",
          value: "projectStatus",
          width: "110px"
        },

        {
          label: "Action",
          value: "action",
          width: "auto"
        },
        {
          label: "Capex(w/ VAT)",
          value: "capex",
          width: "120px"
        },
        {
          label: "Opex(w/ VAT)",
          value: "opex",
          width: "110px"
        }
      ],
      total: 100,
      loading: false,
      currentPage: 1,
      pagenum: 20,
      tableHeight: window.innerHeight - 190,
      multipleSelection: [],
      POSCode: "",
      ProjectCode: "",
      Teams: [],
      TeamOptions: [],
      RegionOptions: ["East", "North", "South", "West"],
      Regions: [],
      //POSCode: "",
      //ProjectCode: "",
      ProvinceOptions: [],
      CityOptions: [],
      Provinces: [],
      Citys: [],
      POSName: "",
      Action: "",
      ActionOptions: [],
      ProjectStatus: [],
      ProjectStatusOptions: ["Pipeline","Finish"],
      YearOption: [],
      Year: [new Date().getFullYear()-1,new Date().getFullYear(),new Date().getFullYear()+1],
      GroupCustomers: [],
      GroupCustomerOptions: [],
      dialogUploadVisible:false,
      errShow:false,
      filelist: [],
      isadminoras:false,
      isntp:false
    };
  },
  computed: {
    check_Teams: {
      get() {
        if (this.Teams.length === this.TeamOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Provinces: {
      get() {
        if (this.Provinces.length === this.ProvinceOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Citys: {
      get() {
        if (this.Citys.length === this.CityOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Regions: {
      get() {
        if (this.Regions.length === this.RegionOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Action: {
      get() {
        if (this.Action.length === this.ActionOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_GroupCustomers: {
      get() {
        if (this.GroupCustomers.length === this.GroupCustomerOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    }
  },
  created() {
    this.GetTeam();
    this.GetCRAction();
    this.GetGroupCustomer();
  },
  methods: {
    tableHeaderCell({ column }) {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell({ column }) {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleSizeChange(val) {
      this.pagenum = val;
      this.BindData(this.currentPage);
    },
    BindData(pageIndex) {
      var provinces = [];
      var citys = [];
      if (this.Provinces.length > 0) {
        this.Provinces.forEach(element => {
          provinces.push(this.ProvinceOptions.find(p => p.id == element));
        });
      }
      if (this.Citys.length > 0) {
        this.Citys.forEach(element => {
          citys.push(this.CityOptions.find(p => p.id == element));
        });
      }

      this.currentPage = pageIndex;
      this.loading = true;
      this.$api
        .post("/CR/GetBigTable", {
          currentpage: pageIndex,
          page: this.pagenum,
          posCode: this.POSCode,
          projectCode: this.ProjectCode,
          posName: this.POSName,
          teams: this.Teams,
          regions: this.Regions,
          provinces: provinces,
          citys: citys,
          actions: this.Action,
          projectStatus: this.ProjectStatus,
          groupCustomers: this.GroupCustomers,
          year:this.Year.toString()
        })
        .then(res => {
          if (res.data.status == true) {
            res.data.content.forEach((element) => {
              element.capex = this.transferToDecimal(element.capex);
              element.opex = this.transferToDecimal(element.opex);
            });
            this.tableData = res.data.content;            
            this.total = res.data.total;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          }
          this.loading = false;
        });
    },
    Init() {
      this.BindData(1);
    },
    transferToDecimal(cellvalues) {
      //if (!!cellvalues) {
        if (cellvalues>=0) {
          cellvalues=parseFloat(cellvalues).toFixed(2);
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        //}
      } else {
        return cellvalues;
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      const arr = this.tableData.map(x => x[prop]);
      arr.push(label);
      return this.getMaxLength(arr) + 20 + "px";
    },
    search() {
      let params = {
        POSCode: "",
        ProjectCode: "",
        POSName: "",
        Teams: [],
        Regions: [],
        Provinces: [],
        Citys: [],
        Action: []
      };
      this.BindData(1);
    },
    goNextPath(row) {
      this.$router.push({
        name: "CRDataBaseDetail",
        params: {
          id: row.application
        }
      });
    },
    keyDown(e) {
      debugger;
      if (e.ctrlKey && e.keyCode == 13) {
        //用户点击了ctrl+enter触发
        this.search();
      }
    },
    GetCRAction() {
      this.$api
        .get("/CR/GetCRAction", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.ActionOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    GetTeam() {
      this.$api
        .get("/Task/GetTeam", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.TeamOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    GetProvinces() {
      if (this.Regions.length > 0) {
        this.$api
          .post("/Task/GetProvinces", { strs: this.Regions }, res => {})
          .then(res => {
            if (res.data.status) {
              this.ProvinceOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.Provinces = [];
        this.ProvinceOptions = [];
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    GetCitys() {
      if (this.Provinces.length > 0) {
        this.$api
          .post("/Task/GetCitys", { ids: this.Provinces }, res => {})
          .then(res => {
            if (res.data.status) {
              this.CityOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.CityOptions = [];
        this.Citys = [];
      }
    },
    GetGroupCustomer() {
      this.$api
        .get("/Task/GetGroupCustomer", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.GroupCustomerOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        });
    },
    selectAll_Teams(checked) {
      if (checked) {
        this.Teams = this.TeamOptions.map(d => d);
      } else {
        this.Teams = [];
      }
    },
    selectAll_Provinces(checked) {
      if (checked) {
        this.Provinces = this.ProvinceOptions.map(d => d.id);
      } else {
        this.Provinces = [];
      }
      this.GetCitys();
    },
    selectAll_Citys(checked) {
      if (checked) {
        this.Citys = this.CityOptions.map(d => d.id);
      } else {
        this.Citys = [];
      }
    },
    selectAll_Actions(checked) {
      if (checked) {
        this.Action = this.ActionOptions.map(d => d.id);
      } else {
        this.Action = [];
      }
    },
    selectAll_Regions(checked) {
      if (checked) {
        this.Regions = this.RegionOptions.map(d => d);
      } else {
        this.Regions = [];
      }
      this.GetProvinces();
    },
    getYearOption() {
      let year = new Date().getFullYear();
      this.YearOption.push("All",year - 1, year, year + 1);
    },
    selectAll_GroupCustomers(checked) {
      if (checked) {
        this.GroupCustomers = this.GroupCustomerOptions.map(d => d);
      } else {
        this.GroupCustomers = [];
      }
    },
    Import() {
      this.dialogUploadVisible = true;
    },
    submitUpload() {
      var files = this.$refs.upload.uploadFiles;
      if (files == 0) {
          return this.$message({
              message: 'Please choose a file',
              type: 'error',
          });
      } else {
          this.$refs.upload.submit();
      }
    },
    requestFile(param) {           
      var _this = this;
      _this.$refs.upload.clearFiles();
      var fileObj = param.file;
      var formData = new FormData(); // FormData 对象
      formData.append('file', fileObj);
      this.$api.post("/CR/Upload",formData, { responseType: 'blob' }, { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(res=>{
          if(res.data.status)
          {
            this.$message({
              type: "success",
              message: res.data.message
            });
          }else{
            if(res.data.message!="模板不对")
              this.errShow=true;
            else
              this.errShow=false;
            this.$message({
              type: "error",
              message: res.data.message
            });
          }
        },err =>{
          this.$message({
              type: "error",
              message: res.data.message
            });
        });    
    },
    handleChange(file,filelist)
    {
      const newfile=filelist.slice(-1);
      this.filelist=newfile;
    },
    Close(){
      this.dialogUploadVisible=false;
      this.filelist=[];
      this.errShow=false;      
    },
    download(type){
      this.$api
        .get("/CR/ExportFileTemp",{type:type},"arraybuffer")
        .then((res) => {
          if(res.status=="200")
          {
            let fileName= res.headers['content-disposition'].split("attachment; filename=")[1];  
            fileName=fileName.split(";")[0];      
            Download(res.data, fileName);
            //loading.close();
          } else {
              this.$message({ message: res.data.message, type: "warring" });
             // loading.close();
          }
        });
      },
    Export(){
      this.POSCode='';
      this.ProjectCode='';
      this.POSName='';
      this.Teams=[];
      this.Regions=[];
      this.Citys=[];
      this.Provinces=[];
      this.Action=[];
      this.ProjectStatus=[];
      this.GroupCustomers=[];
      const loading = this.$loading({
        lock: true,
        text: "Downoad...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$api
        .get("/CR/ExportFile",{Financial_Year:this.Year.join()},"arraybuffer")
        .then((res) => {
          if(res.status=="200")
          {
            let fileName= res.headers['content-disposition'].split("attachment; filename=")[1];  
            fileName=fileName.split(";")[0];      
            Download(res.data, fileName);
            loading.close();
          } else {
              this.$message({ message: res.data.message, type: "warring" });
              loading.close();
          }          
        });
        //loading.close();
      },
    //   IsAdminOrAs() {
    //   this.$api
    //     .get("/Login/IsAdminOrAs/", {}, (res) => {})
    //     .then((res) => {
    //       this.isadminoras = res.data;          
    //     });
    //  },
      IsNTP() {
        this.$api.get("/Login/IsAdminOrAs/", {}, (res) => {})
        .then((res) => {
          this.isadminoras = res.data;   
          if(this.isadminoras)
          {
            this.isntp=this.isadminoras
          }else{
              this.$api
            .get("/Login/IsNTP/", {}, (res) => {})
            .then((res) => {
              this.isntp = !res.data;
            });
          }           
        });        
    }
  },
  mounted() {
    //this.IsAdminOrAs();
    this.Init();
    this.getYearOption();    
    this.IsNTP();
  }
};
</script>

<style lang="scss" scoped>
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.d-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
  margin: auto;
  width: 94%;
  &.d-flex-first {
    margin-top: 30px;
  }
  .flex-item {
    width: 25%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    padding-left: 10px;

    overflow: hidden;
    margin-bottom: 15px;
    .label {
      padding-right: 5px;
      min-width: 120px;
      text-align: right;
    }
    &:nth-child(4n-3) {
      padding-left: 0;
    }
  }
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .CR-btn {
    display: flex;
    justify-content: end;
    .button-search {
      background-color: #e6a23c;
      border: 0px #e6a23c;
      color: #ffff;
    }
  }
}
.cr-table {
  width: 100%;

  .div-pagination {
    text-align: right;
    margin-bottom: 10px;
    display: inline-block;
    width: 100%;
    padding-top: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/CRDataBase.vue